// @flow

import React, { Component } from 'react';
import PDF from 'react-pdf-js';
import { withTranslation, WithTranslation } from 'react-i18next';
import Button from './shared/Button.js';

import type { Record } from '../types/resource';

type State = {
  page: number,
  pages: number,
  scale: number,
  rotate: number
}

type Props = {
  record?: Record,
  pdfSrc?: string,
  imgSrc?: string,
  text?: string,
  onDownload: (e: Event) => void
} & WithTranslation

// key codes
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const MAX_SCALE = 5;
const MIN_SCALE = 1;

class DocumentViewer extends Component<Props, State> {
  state: State = {
    page: 1,
    pages: 1,
    scale: 1.0,
    rotate: 0
  };

  props: Props

  componentWillMount = () => {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  onDocumentComplete = (pages: number) => {
    this.setState({ page: 1, pages });
  }

  onPageComplete = (page: number) => {
    this.setState({ page });
  }

  handlePrevious = () => {
    if (this.state.page !== 1) {
      this.setState({ page: this.state.page - 1 });
    }
  }

  handleNext = () => {
    if (this.state.page !== this.state.pages) {
      this.setState({ page: this.state.page + 1 });
    }
  }

  handleRotate = () => {
    this.setState({
      rotate: this.state.rotate + 90
    });
  }

  handleKeyDown = (event) => {
    if (event.keyCode === LEFT_ARROW && this.state.page !== 1) {
      this.handlePrevious();
    } else if (event.keyCode === RIGHT_ARROW && this.state.page !== this.state.pages) {
      this.handleNext();
    }
  }

  handleScaleUp = () => {
    if (this.state.scale < MAX_SCALE) {
      this.setState({
        scale: this.state.scale + 0.5
      });
    }
  }

  handleScaleDown = () => {
    if (this.state.scale > MIN_SCALE) {
      this.setState({
        scale: this.state.scale - 0.5
      });
    }
  }

  renderPagination(page: number, pages: number): any {
    const { t } = this.props;
    const iconNames = {
      download: 'ic-download',
      zoomOut: 'ic-zoom-out',
      zoomIn: 'ic-zoom-in',
      rotate: 'ic-rotate',
      previous: 'ic-arrow-back',
      next: 'ic-arrow-forward'
    };

    return (
      <nav className='pdf-controls'>
        {this.props.onDownload ? (
          <Button
            title={t('download_PDF')}
            className='is-round is-secondary'
            onClick={this.props.onDownload}
            iconName={iconNames.download}
          />
        ) : ''}
        <div className='scale-control'>
          <Button
            title={t('zoom_out')}
            className='is-round is-secondary'
            onClick={this.handleScaleDown}
            iconName={iconNames.zoomOut}
            isDisabled={this.state.scale <= MIN_SCALE}
          />

          <Button
            title={t('zoom_in')}
            className='is-round is-secondary'
            onClick={this.handleScaleUp}
            iconName={iconNames.zoomIn}
            isDisabled={this.state.scale >= MAX_SCALE}
          />

          <Button
            title={t('rotate_page')}
            className='is-round is-secondary'
            onClick={this.handleRotate}
            iconName={iconNames.rotate}
          />
        </div>

        <div className='pagination-control'>
          <Button
            title={t('previous_page')}
            className='is-round is-secondary'
            onClick={this.handlePrevious}
            iconName={iconNames.previous}
            isDisabled={page === 1}
          />
          <Button
            title={t('next_page')}
            className='is-round is-secondary'
            onClick={this.handleNext}
            iconName={iconNames.next}
            isDisabled={page === pages}
          />
        </div>
      </nav>
    );
  }

  render() {
    let pagination = null;
    if (this.state.pages) {
      pagination = this.renderPagination(this.state.page, this.state.pages);
    }
    return (
      <div className='document-viewer-container viewer-container'>
        {this.props.imgSrc &&
          <div className='is-centered'>
            <img
              src={this.props.imgSrc}
              alt={this.props.record ? this.props.record.file_name : ''}
              style={{ maxWidth: '100%' }}
            />
          </div>
        }
        {this.props.text &&
          <div className='is-centered'>
            <pre>{this.props.text}</pre>
          </div>
        }
        {this.props.pdfSrc &&
          <div className='is-centered'>
            <PDF
              file={this.props.pdfSrc}
              page={this.state.page}
              scale={this.state.scale}
              rotate={this.state.rotate}
              onDocumentComplete={this.onDocumentComplete}
              onPageComplete={this.onPageComplete}
            />
            {pagination}
          </div>
        }
      </div>
    );
  }
}

export default withTranslation('documentViewer')(DocumentViewer);



// WEBPACK FOOTER //
// ./src/components/document-viewer.js